import { render } from "./BlModelExporter.vue?vue&type=template&id=5bbb6a5c&scoped=true"
import script from "./BlModelExporter.vue?vue&type=script&lang=js"
export * from "./BlModelExporter.vue?vue&type=script&lang=js"

import "./BlModelExporter.vue?vue&type=style&index=0&id=5bbb6a5c&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbb6a5c"]])

export default __exports__